<script>
import { reactive } from 'vue'

export default {
  data: () => ({
    filters: [
      { text: 'Found', value: 'FOUND', state: true, count: null },
      { text: 'Converted', value: 'CONVERTED', state: true, count: null },
      {
        text: 'Malformed',
        value: 'MALFORMED',
        state: false,
        count: null,
        style: reactive({ color: 'red' }),
      },
      {
        text: 'Unresolved',
        value: 'NOT_RESOLVED',
        state: false,
        count: null,
        style: reactive({ color: 'red' }),
      },
      {
        text: 'Duplicate',
        value: 'DUPLICATE',
        state: false,
        count: null,
        style: reactive({ color: 'red' }),
      },
    ],
  }),

  computed: {
    filteredFound() {
      return this.found.filter(
        (s) =>
          (s.result === 'FOUND' && this.filters.find((s) => s.value === 'FOUND').state) ||
          (s.result === 'CONVERTED' && this.filters.find((s) => s.value === 'CONVERTED').state) ||
          (s.result === 'MALFORMED' && this.filters.find((s) => s.value === 'MALFORMED').state) ||
          (s.result === 'NOT_RESOLVED' && this.filters.find((s) => s.value === 'NOT_RESOLVED').state) ||
          (s.result === 'DUPLICATE' && this.filters.find((s) => s.value === 'DUPLICATE').state),
      )
    },
  },

  watch: {
    found() {
      this.setFoundCounts()
    },
  },

  methods: {
    setFoundCounts() {
      this.filters.find((s) => s.value === 'FOUND').count = this.found.filter((s) => s.result === 'FOUND').length
      this.filters.find((s) => s.value === 'CONVERTED').count = this.found.filter(
        (s) => s.result === 'CONVERTED',
      ).length
      this.filters.find((s) => s.value === 'MALFORMED').count = this.found.filter(
        (s) => s.result === 'MALFORMED',
      ).length
      this.filters.find((s) => s.value === 'NOT_RESOLVED').count = this.found.filter(
        (s) => s.result === 'NOT_RESOLVED',
      ).length
      this.filters.find((s) => s.value === 'DUPLICATE').count = this.found.filter(
        (s) => s.result === 'DUPLICATE',
      ).length
    },
  },
}
</script>
